module.exports = __webpack_public_path__ + "img/027-unicorn.9054eb47.png";